<template>
  <div class="flex flex-col gap-y-5">
    <div>
      <h4 class="text-xl text-primary">{{ $t('securityHeaderMSG1') }}</h4>
      <div class="ltr:font-sans text-sm flex flex-col gap-y-2">
        <p>{{ $t('securityHeaderMSG2') }}</p>
        <p>{{ $t('securityHeaderMSG5') }}</p>
        <p>{{ $t('securityHeaderMSG6') }}</p>
      </div>
    </div>
    <div>
      <h5 class="text-lg">{{ $t('securityHeaderMSG7') }}</h5>
      <ol class="list-decimal ltr:font-sans text-sm flex flex-col gap-y-2 ps-8 pt-1">
        <li>{{ $t('securityHeaderMSG2') }}</li>
        <li>{{ $t('securityHeaderMSG5') }}</li>
        <li>{{ $t('securityHeaderMSG6') }}</li>
      </ol>
    </div>
    <div>
      <h5 class="text-lg">{{ $t('securityHeaderMSG11') }}</h5>
      <ol class="list-decimal ltr:font-sans text-sm flex flex-col gap-y-2 ps-8 pt-1">
        <li>{{ $t('securityHeaderMSG12') }}</li>
        <li>{{ $t('securityHeaderMSG13') }}</li>
        <li>{{ $t('securityHeaderMSG14') }}</li>
      </ol>
    </div>
    <div>
      <h5 class="text-lg">{{ $t('securityHeaderMSG15') }}</h5>
      <ol class="list-decimal ltr:font-sans text-sm flex flex-col gap-y-2 ps-8 pt-1">
        <li>{{ $t('securityHeaderMSG16') }}</li>
        <li>{{ $t('securityHeaderMSG17') }}</li>
        <li>{{ $t('securityHeaderMSG18') }}</li>
        <li>{{ $t('securityHeaderMSG19') }}</li>
      </ol>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
